var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { markRaw, createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M3 10a7 7 0 1 0 14 0a7 7 0 1 0-14 0m18 11l-6-6"
    }, null, -1)
  ]));
}
__name(render, "render");
const IconSearch = markRaw({ name: "tabler-search", render });
export {
  IconSearch as default
};
//# sourceMappingURL=search.js.map
